import {inject, Pipe, PipeTransform} from '@angular/core';
import {DateMappingService} from 'src/app/services/mapping/date-mapping/date-mapping.service';
import {TagDateDisplayPipeConfig} from '../../models/tag/tag-date-display-pipe-config.model';

@Pipe({
    name: 'tagDateDisplay',
    standalone: true,
})
export class TagDateDisplayPipe implements PipeTransform {
    private readonly dateMappingService: DateMappingService = inject(DateMappingService);

    public transform(config: TagDateDisplayPipeConfig): string {
        if (!config.value) {
            return '';
        }

        const date = this.dateMappingService.mapStringToDate(config.value);
        if (!date) {
            return config.value;
        }

        switch (config.format) {
            case 'D':
                return this.dateMappingService.mapDateToLongLocaleDateString(date, !!config.isUsingBrowserLocale);
            case 'd':
                return this.dateMappingService.mapDateToShortLocaleDateString(date, !!config.isUsingBrowserLocale);
            case 'g':
                return this.dateMappingService.mapDateToShortLocaleDateTimeString(date, !!config.isUsingBrowserLocale);
            default:
                if (config.isDefaultTagSource) {
                    return this.dateMappingService.mapDateToShortLocaleDateTimeString(date, !!config.isUsingBrowserLocale);
                }
                return this.dateMappingService.mapDateToShortLocaleDateString(date, !!config.isUsingBrowserLocale);
        }
    }
}
